/* eslint-disable consistent-return */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */

import React, { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import {
  getFlightTicketApi,
  emailFlightOptions,
  addMarkupInTicket,
} from '../../api/flightApi';
import {
  DATE_MONTH_YEAR_VIEW_FORMAT,
  NAVIGATION_ROUTES,
} from '../../shared/constants/Constants';
import {
  formatCurrency,
  formatBookingDate,
  formatDate,
  formatTimeString,
  hideHeaderFooter,
  showHeaderFooter,
} from '../../shared/helper-utils/appUtils';
import { getObjectFromLS } from '../../shared/helper-utils/localStorage';
import AppLoading from '../../shared/components/app-loading/AppLoading';
import AppLink from '../../shared/components/app-link/AppLink';
import AppButton from '../../shared/components/app-button/AppButton';
import './FlightOrderDetailsPage.scss';
import AppModal from '../../shared/components/app-modal/AppModal';
import AppTextInput from '../../shared/components/app-text-input/AppTextInput';
import AppNumberInput from '../../shared/components/app-number-input/AppNumberInput';
import AppFlightLogo from '../../shared/components/app-flight-logo/AppFlightLogo';
import { APP_USER_PROFILE } from '../../saas/AppStorageStaticNames';
import { useAppContext } from '../../saas/AppConfigWrapper';

function FlightOrderDetailsPage() {
  const { appConfig } = useAppContext();
  const navigate = useNavigate();
  const { transactionId } = useParams();
  const [hasTicket, setHasTicket] = useState(undefined);
  const [isLoading, setIsLoading] = useState(false);
  const flightInvoiceRef = useRef(null);
  const paymentSummaryRef = useRef(null);
  const passengerRef = useRef(null);
  const fareSummaryRef = useRef({});
  const flightSectorsRef = useRef({});
  const taxNodesRef = useRef([]);
  const sectorFareTypesRef = useRef({});
  const sectorFullNameMapRef = useRef({});
  const barCodesRef = useRef({});
  const agentDetailsRef = useRef(null);
  const flightTicketRef = useRef(null);
  const flightCancellationDetailRef = useRef([]);
  const canxPassengerRef = useRef([]);
  const debitNoteRef = useRef([]);
  const [fareDetailsStr, setFareDetailsStr] = useState(undefined);
  const onwardSectorRef = useRef([]);
  const returnSectorRef = useRef([]);
  const onwardPaxRef = useRef([]);
  const returnPaxRef = useRef([]);
  const passengerSSRRef = useRef([]);
  const [showRemarks, setShowRemarks] = useState(false);
  const [showEmailModal, setShowEmailModal] = useState(false);
  const [toEmail, setToEmail] = useState('');
  const [showMarkupModal, setShowMarkupModal] = useState(false);
  const originRef = useRef('');
  const destinationRef = useRef('');

  useEffect(() => {
    hideHeaderFooter();
    return () => showHeaderFooter();
  }, []);

  const setFareSummary = (data) => {
    const invoice = data.FullFlightDetails.FlightInvoice;

    let FlightApiPricingLog = {};
    if (
      invoice.UpdatedFlightApiPricingLogs &&
      invoice.UpdatedFlightApiPricingLogs !== '' &&
      invoice.UpdatedFlightApiPricingLogs.FlightApiPricingLog
    ) {
      FlightApiPricingLog =
        invoice.UpdatedFlightApiPricingLogs.FlightApiPricingLog;
    } else {
      FlightApiPricingLog = invoice.FlightApiPricingLogs.FlightApiPricingLog;
    }
    let FullBreakup = {};
    if (FlightApiPricingLog?.ResponseXml) {
      FullBreakup = FlightApiPricingLog?.ResponseXml.FullBreakup;
    }
    let taxNodes = [];
    if (FullBreakup && FullBreakup.TotalBreakup) {
      taxNodes = Array.isArray(FullBreakup.TotalBreakup.TaxNode)
        ? FullBreakup.TotalBreakup.TaxNode
        : [FullBreakup.TotalBreakup.TaxNode];
    } else if (FullBreakup && FullBreakup.AdultBreakup) {
      taxNodes = Array.isArray(FullBreakup.AdultBreakup.TaxNode)
        ? FullBreakup.AdultBreakup.TaxNode
        : [FullBreakup.AdultBreakup.TaxNode];
    }
    fareSummaryRef.current = {
      adultBaseFare: FullBreakup.AdultBase,
      childBaseFare: FullBreakup.ChildBase,
      infantBaseFare: FullBreakup.InfantBase,
      totalFare: 0,
    };

    let { PassengerSSRRecord } = invoice.PassengerSSRRecords;
    if (PassengerSSRRecord !== undefined && PassengerSSRRecord !== '') {
      PassengerSSRRecord = Array.isArray(PassengerSSRRecord)
        ? PassengerSSRRecord
        : [PassengerSSRRecord];
    } else {
      PassengerSSRRecord = [];
    }
    let seatPrice = 0;
    let mealPrice = 0;
    let baggagePrice = 0;
    let specialSsrPrice = 0;
    let hasSeat = false;
    let hasMeal = false;
    let hasBaggage = false;
    let hasSpecialSsr = false;
    PassengerSSRRecord.forEach((record) => {
      if (
        record.SSRType.toLowerCase() === 'seat' &&
        record.Status !== 'failed'
      ) {
        seatPrice += parseInt(record.ChargeableAmount, 10);
        hasSeat = true;
      }
      if (
        record.SSRType.toLowerCase() === 'meal' &&
        record.Status !== 'failed'
      ) {
        mealPrice += parseInt(record.ChargeableAmount, 10);
        hasMeal = true;
      }
      if (
        record.SSRType.toLowerCase() === 'baggage' &&
        record.Status !== 'failed'
      ) {
        baggagePrice += parseInt(record.ChargeableAmount, 10);
        hasBaggage = true;
      }
      if (
        record.SSRType.toLowerCase() === 'specialssr' &&
        record.Status !== 'failed'
      ) {
        specialSsrPrice += parseInt(record.ChargeableAmount, 10);
        hasSpecialSsr = true;
      }
    });
    fareSummaryRef.current.hasSeat = hasSeat;
    fareSummaryRef.current.hasMeal = hasMeal;
    fareSummaryRef.current.hasBaggage = hasBaggage;
    fareSummaryRef.current.hasSpecialSsr = hasSpecialSsr;
    fareSummaryRef.current.seatPrice = seatPrice;
    fareSummaryRef.current.mealPrice = mealPrice;
    fareSummaryRef.current.baggagePrice = baggagePrice;
    fareSummaryRef.current.specialSsrPrice = specialSsrPrice;
    const adultTotal = FullBreakup.TotalBase
      ? FullBreakup.TotalBase + FullBreakup.TotalTax
      : (FullBreakup.AdultBase + FullBreakup.AdultTax) *
        flightInvoiceRef.current.FlightRecord.NumAdults;
    const GSTDifference = taxNodes.find((tx) => tx.TaxName === 'GSTDifference');
    taxNodes.forEach((tx) => {
      if (tx.TaxName === 'GST') {
        tx.TaxValue += GSTDifference ? GSTDifference.TaxValue : 0;
      }
    });
    let gstDiff = 0;
    if (GSTDifference) {
      gstDiff = GSTDifference.TaxValue;
    }
    fareSummaryRef.current.totalSSR =
      seatPrice + mealPrice + baggagePrice + specialSsrPrice;
    fareSummaryRef.current.totalFare +=
      adultTotal +
      seatPrice +
      mealPrice +
      baggagePrice +
      specialSsrPrice +
      gstDiff;
    taxNodesRef.current = taxNodes;
    let hiddenMarkup = 0;
    let { PassengerFare } = invoice.PassengerFares;
    if (PassengerFare !== undefined && PassengerFare !== '') {
      PassengerFare = Array.isArray(PassengerFare)
        ? PassengerFare
        : [PassengerFare];
    } else {
      PassengerFare = [];
    }
    PassengerFare.forEach((record) => {
      if (record.FareComponentId === 83) {
        hiddenMarkup += record.Amount;
      }
    });
    fareSummaryRef.current.hmarkup = hiddenMarkup;
  };

  const getData = async () => {
    setIsLoading(true);
    const userProfile = getObjectFromLS(APP_USER_PROFILE);
    const response = await getFlightTicketApi(
      transactionId,
      userProfile.agentId,
    );
    if (response && response.ApiStatus && response.ApiStatus.Status === 'OK') {
      const { FlightInvoice, UserDetails } =
        response.ApiStatus.Result.FullFlightDetails;
      flightInvoiceRef.current = FlightInvoice;
      agentDetailsRef.current = UserDetails.UserProfile;
      originRef.current = FlightInvoice.FlightRecord.Origin;
      destinationRef.current = FlightInvoice.FlightRecord.Destination;
      const { FlightTicket } = FlightInvoice.FlightTickets;
      flightTicketRef.current = Array.isArray(FlightTicket)
        ? FlightTicket
        : [FlightTicket];
      if (response.ApiStatus.Result.FullFlightDetails.CreditDebitNotes) {
        const { CreditDebitNote } =
          response.ApiStatus.Result.FullFlightDetails.CreditDebitNotes;
        const creditDebitNotes = Array.isArray(CreditDebitNote)
          ? CreditDebitNote
          : [CreditDebitNote];
        debitNoteRef.current = creditDebitNotes.filter(
          (note) => note.TxType === 'DEBITNOTE',
        );
      }
      if (
        response.ApiStatus.Result.FullFlightDetails.FlightCancellationDetail
      ) {
        const canxDetail =
          response.ApiStatus.Result.FullFlightDetails.FlightCancellationDetail;
        flightCancellationDetailRef.current = Array.isArray(canxDetail)
          ? canxDetail
          : [canxDetail];
      }
      flightCancellationDetailRef.current.forEach((detail) => {
        const pax = detail.FlightCanxPassengers.FlightCanxPassenger;
        if (!Array.isArray(pax)) {
          detail.FlightCanxPassengers.FlightCanxPassenger = [
            detail.FlightCanxPassengers.FlightCanxPassenger,
          ];
        }
      });
      if (FlightInvoice.BarCodes) {
        barCodesRef.current = Array.isArray(FlightInvoice.BarCodes.BarCode)
          ? FlightInvoice.BarCodes.BarCode
          : [FlightInvoice.BarCodes.BarCode];
      }
      if (FlightInvoice.PassengerSSRRecords !== '') {
        const { PassengerSSRRecord } = FlightInvoice.PassengerSSRRecords;
        passengerSSRRef.current = Array.isArray(PassengerSSRRecord)
          ? PassengerSSRRecord
          : [PassengerSSRRecord];
      }
      let { SectorRecord } = flightInvoiceRef.current.SectorRecords;
      SectorRecord = Array.isArray(SectorRecord)
        ? SectorRecord
        : [SectorRecord];
      sectorFareTypesRef.current = SectorRecord.reduce((acc, cur) => {
        if (!acc[cur]) {
          acc[`${cur.Origin} - ${cur.Destination}`] = cur.Faretype;
        }
        return acc;
      }, {});
      sectorFullNameMapRef.current = SectorRecord.reduce((acc, sector) => {
        if (acc[sector.Origin] === undefined) {
          acc[sector.Origin] =
            sector.OriginFullName === '-'
              ? sector.Origin
              : sector.OriginFullName;
        }
        if (acc[sector.Destination] === undefined) {
          acc[sector.Destination] =
            sector.DestinationFullName === '-'
              ? sector.Destination
              : sector.DestinationFullName;
        }
        return acc;
      }, {});
      flightSectorsRef.current = SectorRecord;
      paymentSummaryRef.current = {
        TotalAmount: FlightInvoice.FlightRecord.TotalAmount,
        SSRAmount: FlightInvoice.FlightRecord.SSRAmount,
        PaymentMode: FlightInvoice.FlightRecord.PaymentMode,
        PaymentStatus: FlightInvoice.FlightRecord.PaymentStatus,
        BookingDate: FlightInvoice.FlightRecord.BookingDate,
      };
      let { PassengerRecord } = flightInvoiceRef.current.PassengerRecords;
      PassengerRecord = Array.isArray(PassengerRecord)
        ? PassengerRecord
        : [PassengerRecord];
      passengerRef.current = PassengerRecord;
      passengerRef.current.forEach((pax) => {
        const paxSectors = [];
        const ft = flightTicketRef.current.find((x) => x.Paxid === pax.Paxid);
        if (ft) {
          pax.flightTicketNumber = ft.TicketNumber;
          pax.flightAirlinePnr = ft.AirlinePnr;
        }
        flightSectorsRef.current.forEach((sector) => {
          const meal = [];
          const seat = [];
          const baggage = [];
          const specialSSR = [];
          if (passengerSSRRef.current.length > 0) {
            passengerSSRRef.current.forEach((record) => {
              if (
                record.Origin === sector.Origin &&
                record.Destination === sector.Destination &&
                record.Paxid === pax.Paxid
              ) {
                if (record.SSRType === 'meal') {
                  meal.push(record.SSR);
                }
                if (record.SSRType === 'seat') {
                  seat.push(record.SSRCode);
                }
                if (record.SSRType === 'baggage') {
                  baggage.push(record.SSR);
                }
                if (record.SSRType === 'specialssr') {
                  specialSSR.push(record.SSR);
                }
              } else if (
                record.Origin === originRef.current &&
                record.Destination === destinationRef.current &&
                record.Paxid === pax.Paxid &&
                record.TripNumber === 1
              ) {
                if (record.SSRType === 'baggage') {
                  baggage.push(record.SSR);
                }
                if (record.SSRType === 'specialssr') {
                  specialSSR.push(record.SSR);
                }
              } else if (
                record.Destination === originRef.current &&
                record.Origin === destinationRef.current &&
                record.Paxid === pax.Paxid &&
                record.TripNumber === 2
              ) {
                if (record.SSRType === 'baggage') {
                  baggage.push(record.SSR);
                }
                if (record.SSRType === 'specialssr') {
                  specialSSR.push(record.SSR);
                }
              }
            });
          }
          const paxSector = barCodesRef.current.find(
            (record) =>
              record.Paxid === pax.Paxid &&
              `${record.Origin}-${record.Destination}` ===
                `${sector.Origin}-${sector.Destination}`,
          );
          if (paxSector) {
            paxSectors.push({
              sectorInfo: `${paxSector.Origin}-${paxSector.Destination}`,
              sectorBaggage:
                pax.Type.toLowerCase() === 'infant'
                  ? ''
                  : sector.BaggageInfo.split(',')[0],
              sectorBarcode: paxSector.ImagePath,
              sectorSSr: [seat, meal, baggage, specialSSR],
            });
          }
        });
        pax.paxSectors = paxSectors;
      });
      onwardPaxRef.current = passengerRef.current.filter(
        (pax) => pax.SegmentNumber === 1,
      );
      returnPaxRef.current = passengerRef.current.filter(
        (pax) => pax.SegmentNumber === 2,
      );
      onwardSectorRef.current = flightSectorsRef.current.filter(
        (sector) => sector.FlightType.toLowerCase() === 'onward',
      );
      returnSectorRef.current = flightSectorsRef.current.filter(
        (sector) => sector.FlightType.toLowerCase() === 'return',
      );
      setFareDetailsStr(
        flightInvoiceRef.current.FlightRecord.FareDetails.split('##').map(
          Number,
        ),
      );
      setFareSummary(response.ApiStatus.Result);
      setHasTicket(true);
      setIsLoading(false);
    } else {
      setHasTicket(false);
      setIsLoading(false);
    }
  };

  useEffect(() => {
    getData();
  }, [transactionId]);

  const handleShowRemark = (index) => {
    setShowRemarks((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  const handlePrintRefundReceipt = (txid) => {
    let route = NAVIGATION_ROUTES.FLIGHT.FLIGHT_REFUND_RECEIPT;
    route = route.replace(':transactionId', txid);
    return route;
  };

  // const handleSendEmail = async () => {
  //   const fromName = `${agentDetailsRef.current.FirstName} ${agentDetailsRef.current.LastName}`;
  //   const fromEmail = agentDetailsRef.current.ContactEmail;
  //   const htmlContent = document.getElementById('ticketheader').innerHTML;
  //   if (toEmail === '' || checkValidEmailAddress(toEmail)) {
  //     setAlert({
  //       title: 'Email',
  //       description: 'please enter valid email',
  //       variant: 'error',
  //     });
  //     return false;
  //   }
  //   setIsLoading(true);
  //   const response = await emailFlightOptions(
  //     fromEmail,
  //     fromName,
  //     toEmail,
  //     htmlContent,
  //   );
  //   if (response.Root.Status === 'OK') {
  //     setShowEmailModal(false);
  //     setToEmail('');
  //     setAlert({
  //       title: 'Email',
  //       description: 'Email Sent Successfully',
  //       variant: 'success',
  //     });
  //   } else {
  //     setAlert({
  //       title: 'Email',
  //       description: 'Failed to send Email Please try again',
  //       variant: 'error ',
  //     });
  //   }
  //   setIsLoading(false);
  // };

  // const handleAddMarkup = async () => {
  //   if (markupToAdd === '') {
  //     return false;
  //   }
  //   setIsLoading(true);
  //   const res = await addMarkupInTicket(
  //     getUserAgentId(),
  //     transactionId,
  //     markupToAdd,
  //   );
  //   if (res.Root.Status === 'OK') {
  //     getData();
  //     setShowMarkupModal(false);
  //     setMarkupToAdd('');
  //   } else {
  //     setIsLoading(false);
  //     setAlert({
  //       title: 'Add Markup',
  //       description: res.Root?.Message ? res.Root?.Message : 'cant add markup',
  //       variant: 'error',
  //     });
  //   }
  // };

  return (
    <section className="flight-order-details">
      <AppLoading isLoading={isLoading} />
      {hasTicket !== undefined && hasTicket && (
        <>
          <section
            className="d-flex flex-column gap-2 hide-in-print"
            style={{ position: 'fixed', top: '100px', right: '0' }}
          >
            <AppButton
              variant="green"
              btnText="Ticket"
              onClick={() =>
                window.open(`/flight/ticket/${transactionId}`, '_blank')
              }
            />
            <AppButton
              variant="green"
              btnText="Invoice"
              onClick={() =>
                window.open(`/flight/invoice/${transactionId}`, '_blank')
              }
            />
            <AppButton
              variant="green"
              btnText="Cancel"
              disabled={
                flightInvoiceRef.current.FlightRecord.BookingStatus.toLowerCase() !==
                'confirmed'
              }
              onClick={() =>
                window.open(`/flight/cancellation/${transactionId}`, '_blank')
              }
            />
            {/* <AppButton
              btnText="Add Markup"
              variant="green"
              onClick={() => setShowMarkupModal(true)}
            /> */}
            {/* <AppButton
              btnText="Web CheckIn"
              variant="green"
              // onClick={() => setShowBaggageModal(true)}
            /> */}
            <AppButton
              btnText="Print"
              variant="green"
              onClick={() => window.print()}
            />
            {/* <AppButton
              btnText="Email"
              variant="green"
              onClick={() => setShowEmailModal(true)}
            /> */}
          </section>
          <section className="flight-order-details_container" id="ticketheader">
            <div className="flight-order-details_heading">
              Flight Order Details
            </div>
            <div>
              <div className="table-heading">Flight Order Information</div>
              <div className="flight-order-info-table">
                <table className="w-100">
                  <tbody>
                    <tr>
                      <td>Transaction Id</td>
                      <td>{flightInvoiceRef.current.FlightRecord.Txid}</td>
                      <td>Journey(Type)</td>
                      <td>
                        ({flightInvoiceRef.current.FlightRecord.Origin}-
                        {flightInvoiceRef.current.FlightRecord.Destination})
                        {flightInvoiceRef.current.FlightRecord.JType}
                      </td>
                    </tr>
                    <tr>
                      <td>Booking Date</td>
                      <td>
                        {formatBookingDate(
                          flightInvoiceRef.current.FlightRecord.BookingDate,
                        )}
                      </td>
                      <td>Booking Status</td>
                      <td>
                        {flightInvoiceRef.current.FlightRecord.BookingStatus}
                      </td>
                    </tr>
                    <tr>
                      <td>GDS Pnr</td>
                      <td>{flightInvoiceRef.current.FlightRecord.GdsPnr}</td>
                      <td>Journey Date</td>
                      <td>{flightInvoiceRef.current.FlightRecord.JDate}</td>
                    </tr>
                    <tr>
                      <td>Payment Status</td>
                      <td>
                        {flightInvoiceRef.current.FlightRecord.PaymentStatus}
                      </td>
                      <td>Payment Mode</td>
                      <td>
                        {flightInvoiceRef.current.FlightRecord.PaymentMode}
                      </td>
                    </tr>
                    <tr>
                      <td>Invoice Price</td>
                      <td>
                        {flightInvoiceRef.current.FlightRecord.TotalAmount.toFixed(
                          1,
                        )}
                      </td>
                      <td>Fare Quote Price</td>
                      <td>
                        {flightInvoiceRef.current.FlightRecord.FareQuoteAmount.toFixed(
                          1,
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>Customer Name,Contact:</td>
                      <td>
                        {flightInvoiceRef.current.FlightRecord.PassengerTitle}{' '}
                        {
                          flightInvoiceRef.current.FlightRecord
                            .PassengerFirstName
                        }{' '}
                        {
                          flightInvoiceRef.current.FlightRecord
                            .PassengerLastName
                        }
                        ,{flightInvoiceRef.current.FlightRecord.PassengerEmail},
                        {flightInvoiceRef.current.FlightRecord.PassengerContact}
                        ,{}
                      </td>
                    </tr>
                    <tr>
                      <td>Ip Adddress Details:</td>
                      <td>
                        {flightInvoiceRef.current.FlightRecord.ChannelInfo}
                      </td>
                      <td>Booking Source:</td>
                      <td>
                        {flightInvoiceRef.current.FlightRecord.BookingChannel}
                      </td>
                    </tr>
                    <tr>
                      <td>Promo Details:</td>
                      <td>{flightInvoiceRef.current.FlightRecord.PromoCode}</td>
                      <td>Promo Value:</td>
                      <td>
                        {flightInvoiceRef.current.FlightRecord.PromoValue}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            {flightCancellationDetailRef.current.length > 0 && (
              <div>
                <div className="table-heading">Cancellation Requests</div>
                {flightCancellationDetailRef.current.map((canx, index) => (
                  <div key={canx.FlightCancellation.Txid}>
                    <table className="w-100 details-table">
                      <thead>
                        <tr>
                          <th>TxID</th>
                          <th>Request Date</th>
                          <th>Pax Name</th>
                          <th>JType</th>
                          <th>Commission</th>
                          <th>TotalInvoice</th>
                          <th>Status</th>
                          <th>OTACharge</th>
                          <th>AirlineCharge</th>
                          <th>RefundAmount</th>
                        </tr>
                      </thead>
                      <tbody>
                        {canx.FlightCanxPassengers.FlightCanxPassenger.map(
                          (pax) => (
                            <tr
                              key={`${canx.FlightCancellation.Txid}_${pax.PaxId}`}
                            >
                              <td>{pax.Txid}</td>
                              <td>{canx.FlightCancellation.TxDate}</td>
                              <td>
                                {pax.PaxFirstName}
                                {pax.PaxLastName}
                              </td>
                              <td>
                                {pax.TripNumber === 1 && 'Onward Ticket'}
                                {pax.TripNumber === 2 && 'Return Ticket'}
                              </td>
                              <td>{pax.Commission.toFixed(1)}</td>
                              <td>{pax.TotalInvoice.toFixed(1)}</td>
                              <td>{pax.Status}</td>
                              <td>{pax.CanxChargeOta.toFixed(1)}</td>
                              <td>{pax.CanxChargeAirline.toFixed(1)}</td>
                              <td>{pax.RefundAmount.toFixed(1)}</td>
                            </tr>
                          ),
                        )}
                      </tbody>
                    </table>
                    <div>
                      <div className="d-flex gap-3">
                        <AppLink
                          linkText={
                            showRemarks[index] ? 'Hide Remarks' : 'Show Remarks'
                          }
                          onClick={() => handleShowRemark(index)}
                        />
                        <AppLink
                          linkText="Print Refund Receipt"
                          isLink
                          target="_blank"
                          href={handlePrintRefundReceipt(
                            canx.FlightCancellation.Txid,
                          )}
                        />
                      </div>
                      {showRemarks[index] && (
                        <table
                          key={canx.FlightCancellation.Txid}
                          className="show-remarks-table"
                        >
                          <tbody>
                            <tr>
                              <td>Request Remarks : </td>
                              <td>{canx.FlightCancellation.Remarks}</td>
                            </tr>
                            <tr>
                              <td>Admin Remarks : </td>
                              <td>{canx.FlightCancellation.AdminRemarks}</td>
                            </tr>
                            <tr>
                              <td>Requested By : </td>
                              <td>{canx.FlightCancellation.RequestedBy}</td>
                            </tr>
                          </tbody>
                        </table>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            )}
            {flightSectorsRef.current.length > 0 && (
              <div>
                <div className="table-heading">Order Itineary InforMation</div>
                {onwardSectorRef.current.length > 0 && (
                  <div>
                    <p style={{ color: 'darkRed', fontWeight: 'bold' }}>
                      Onward Journey :{' '}
                      {flightInvoiceRef.current.FlightRecord.Origin}-
                      {flightInvoiceRef.current.FlightRecord.Destination}
                    </p>
                    {onwardSectorRef.current.map((sector, index) => (
                      <div key={`${sector.Origin}_${sector.Destination}`}>
                        <p>
                          <b>
                            Sector {index + 1} : {sector.OriginAirportFullname}{' '}
                            --
                            {'>'} {sector.DestinationAirportFullname}
                          </b>
                        </p>
                        <table className="w-100 details-table">
                          <thead>
                            <tr>
                              <th>Flight No.</th>
                              <th>Departure Date</th>
                              <th>Departure Time</th>
                              <th>Arrival Time</th>
                            </tr>
                          </thead>
                          <tbody className="fw-600">
                            <tr>
                              <td>
                                <AppFlightLogo
                                  carrier={sector.Carrier.substring(0, 2)}
                                  width="30px"
                                  className="me-2"
                                />
                                {sector.Carrier}-{sector.FlightNumber} ( Class -{' '}
                                {sector.BookingClass})
                              </td>
                              <td>{sector.JourneyDate}</td>
                              <td>
                                {sector.Origin}{' '}
                                {formatTimeString(sector.DepartureTime)}
                              </td>
                              <td>
                                {sector.Destination}{' '}
                                {formatTimeString(sector.ArrivalTime)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        {onwardPaxRef.current.length > 0 && (
                          <table className="w-100 details-table">
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Type </th>
                                <th>TicketNumber</th>
                                <th> A.PNR</th>
                                <th>PP NO</th>
                                <th>PP Expiry</th>
                                <th>DOB</th>
                                <th>PP Place</th>
                                <th>Seat</th>
                                <th>Meal</th>
                                <th>Baggage</th>
                                <th>Base Fare</th>
                                <th>Tax</th>
                                <th>YQ</th>
                              </tr>
                            </thead>
                            <tbody>
                              {onwardPaxRef.current.map((pax) => (
                                <tr key={`${pax.Paxid}_${pax.FirstName}`}>
                                  <td>
                                    {pax.Title}.{pax.FirstName} {pax.LastName}
                                  </td>
                                  <td>{pax.Type}</td>
                                  <td>{pax.flightTicketNumber}</td>
                                  <td>{pax.flightAirlinePnr}</td>
                                  <td>{pax.Passport}</td>
                                  <td>{pax.PassportExpiry}</td>
                                  <td>{pax.Dob}</td>
                                  <td>
                                    {pax.PassportPlace.toUpperCase() !==
                                      appConfig?.hotelPaxCountry &&
                                      pax.PassportPlace}
                                  </td>
                                  <td>
                                    {pax.paxSectors[index].sectorSSr[0].join(
                                      ',',
                                    )}
                                  </td>
                                  <td>
                                    {pax.paxSectors[index].sectorSSr[1].join(
                                      ',',
                                    )}
                                  </td>
                                  <td>
                                    {pax.paxSectors[index].sectorSSr[2].join(
                                      ',',
                                    )}
                                  </td>
                                  <td>{pax.BaseFare.toFixed(2)}</td>
                                  <td>{pax.Tax.toFixed(2)}</td>
                                  <td>{pax.FuelSurcharge.toFixed(2)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </div>
                    ))}
                  </div>
                )}
                {returnSectorRef.current.length > 0 && (
                  <div>
                    <p style={{ color: 'darkRed', fontWeight: 'bold' }}>
                      Return Journey :{' '}
                      {flightInvoiceRef.current.FlightRecord.Origin}-
                      {flightInvoiceRef.current.FlightRecord.Destination}
                    </p>
                    {returnSectorRef.current.map((sector, index) => (
                      <div key={`${sector.Origin}_${sector.Destination}`}>
                        <p>
                          <b>
                            Sector {index + 1} : {sector.OriginAirportFullname}{' '}
                            --
                            {'>'} {sector.DestinationAirportFullname}
                          </b>
                        </p>
                        <table className="w-100 details-table">
                          <thead>
                            <tr>
                              <th>Flight No.</th>
                              <th>Departure Date</th>
                              <th>Departure Time</th>
                              <th>Arrival Time</th>
                            </tr>
                          </thead>
                          <tbody className="fw-600">
                            <tr>
                              <td>
                                <AppFlightLogo
                                  carrier={sector.Carrier.substring(0, 2)}
                                  width="30px"
                                  className="me-2"
                                />
                                {sector.Carrier}-{sector.FlightNumber} ( Class -{' '}
                                {sector.BookingClass})
                              </td>
                              <td>{sector.JourneyDate}</td>
                              <td>
                                {sector.Origin}{' '}
                                {formatTimeString(sector.DepartureTime)}
                              </td>
                              <td>
                                {sector.Destination}{' '}
                                {formatTimeString(sector.ArrivalTime)}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                        {returnPaxRef.current.length > 0 && (
                          <table className="w-100 details-table">
                            <thead>
                              <tr>
                                <th>Name</th>
                                <th>Type </th>
                                <th>TicketNumber</th>
                                <th> A.PNR</th>
                                <th>PP NO</th>
                                <th>PP Expiry</th>
                                <th>DOB</th>
                                <th>PP Place</th>
                                <th>Meal</th>
                                <th>Seat</th>
                                <th>Bag</th>
                                <th>Base Fare</th>
                                <th>Tax</th>
                                <th>YQ</th>
                              </tr>
                            </thead>
                            <tbody>
                              {returnPaxRef.current.map((pax) => (
                                <tr key={`${pax.Paxid}_${pax.FirstName}`}>
                                  <td>
                                    {pax.Title}.{pax.FirstName} {pax.LastName}
                                  </td>
                                  <td>{pax.Type}</td>
                                  <td>{pax.flightTicketNumber}</td>
                                  <td>{pax.flightAirlinePnr}</td>
                                  <td>{pax.Passport}</td>
                                  <td>{pax.PassportExpiry}</td>
                                  <td>{pax.Dob !== '2000-01-01' && pax.Dob}</td>
                                  <td>
                                    {pax.PassportPlace.toUpperCase() !==
                                      appConfig?.hotelPaxCountry &&
                                      pax.PassportPlace}
                                  </td>
                                  <td>{pax.ssrMeal}</td>
                                  <td>{pax.ssrSeat}</td>
                                  <td>{pax.ssrBag}</td>
                                  <td>{pax.BaseFare.toFixed(2)}</td>
                                  <td>{pax.Tax.toFixed(2)}</td>
                                  <td>{pax.FuelSurcharge.toFixed(2)}</td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        )}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
            {debitNoteRef.current.length > 0 && (
              <div>
                <div className="table-heading">Related Debit/Credit Notes</div>
                <div>
                  <table className="w-100 details-table">
                    <thead>
                      <tr>
                        <th>Tx id</th>
                        <th>Tx Date</th>
                        <th>Tx Type</th>
                        <th>Amount</th>
                        <th>Towards</th>
                        <th>Reference ID</th>
                        <th>Agent Company</th>
                        <th className="hide-in-print">Print</th>
                      </tr>
                    </thead>
                    {debitNoteRef.current.map((note) => (
                      <tbody key={note.Txid}>
                        <tr>
                          <td>{note.Txid}</td>
                          <td>{note.TxDate}</td>
                          <td>{note.TxType}</td>
                          <td>{note.Amount.toFixed(1)}</td>
                          <td>{note.Towards}</td>
                          <td>{note.ReferenceId}</td>
                          <td>{note.AgentCompany}</td>
                          <td className="hide-in-print">
                            <a
                              href={`/credit-debit-receipt/${note.Txid}`}
                              target="blank"
                            >
                              print
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td colSpan={8} className="text-start">
                            {note.Remarks}
                          </td>
                        </tr>
                      </tbody>
                    ))}
                  </table>
                </div>
              </div>
            )}
            <div>
              <div className="table-heading">Order Fare Details</div>
              <div>
                <table className="w-100 details-table">
                  <thead>
                    <tr>
                      <th>Total Pss</th>
                      <th>BaseFare</th>
                      <th>Tax</th>
                      <th>YQ</th>
                      <th>S.Fee</th>
                      <th>TDS </th>
                      <th>Commission</th>
                      <th>SSR</th>
                      <th>Tfee INV</th>
                      <th>TfeeFQ</th>
                      <th>HC</th>
                      <th>invoice</th>
                      <th>Markup</th>
                      <th>H Markup</th>
                      <th>Farequote</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>{flightInvoiceRef.current.FlightRecord.NumPax}</td>
                      <td>{Math.round(fareDetailsStr[0])}</td>
                      <td>{Math.round(fareDetailsStr[1])}</td>
                      <td>{fareDetailsStr[1] - fareDetailsStr[2]}</td>
                      <td>{Math.round(fareDetailsStr[3])}</td>
                      <td>{Math.round(fareDetailsStr[4])}</td>
                      <td>{Math.round(fareDetailsStr[5])}</td>
                      <td>{Math.round(fareSummaryRef.current.totalSSR)}</td>
                      <td>{Math.round(fareDetailsStr[6])}</td>
                      <td>{Math.round(fareDetailsStr[7])}</td>
                      <td>{Math.round(fareDetailsStr[8])}</td>
                      <td>
                        {Math.round(
                          fareDetailsStr[9] + fareSummaryRef.current.totalSSR,
                        )}
                      </td>
                      <td>{Math.round(fareDetailsStr[10])}</td>
                      <td>{Math.round(fareSummaryRef.current.hmarkup)}</td>
                      <td>
                        {Math.round(
                          fareDetailsStr[11] + fareSummaryRef.current.totalSSR,
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </section>
          {/* {showEmailModal && (
            <AppModal
              modalTitle="Email Ticket"
              showCloseButton
              onModalClose={() => setShowEmailModal(false)}
            >
              <div>
                <div className="d-flex gap-2">
                  <AppTextInput
                    onChange={(e) => setToEmail(e.target.value)}
                    value={toEmail}
                    name="toEmail"
                    placeholderText=""
                    label="Email to Send"
                  />
                  <AppButton
                    btnText="Send Email"
                    onClick={handleSendEmail}
                    variant="outlined"
                  />
                </div>
              </div>
            </AppModal>
          )} */}
          {/* {showMarkupModal && (
            <AppModal
              modalTitle="Add MarkUp"
              showCloseButton
              onModalClose={() => setShowMarkupModal(false)}
            >
              <div>
                <p>Additional Charges to Add</p>
                <div className="d-flex gap-2">
                  <AppNumberInput
                    onChange={(d) => setMarkupToAdd(d)}
                    value={markupToAdd}
                    name="markuptoAdd"
                    placeholderText=""
                    label="Enter Markup"
                  />
                  <AppButton
                    btnText="Add MarkUp"
                    onClick={handleAddMarkup}
                    variant="outlined"
                  />
                </div>
              </div>
            </AppModal>
          )} */}
        </>
      )}
    </section>
  );
}

export default FlightOrderDetailsPage;
